export const SELF_ENROLLMENT_STEPS = {
  LOGIN: 0,
  ELIGIBILITY: 1,
  LICENSE_DETAILS: 2,
  CONTACT_DETAILS: 3,
  ENGLISH_PROFICIENCY: 4,
  LOCATION_SELECTION: 5,
  REMOVED_PROGRAM_SELECTION: 6,
  ADDITIONAL_INFO: 7,
  TRAINING_DATE: 8,
  REMOVED_TUITION_SUMMARY: 9,
  UPLOAD_DOCUMENTS: 10,
  SIGN_DOCUMENTS: 11,
  SIGNED_COMPLETE: 12,
  ENROLLMENT_COMPLETE: 13,
  NOT_ELIGIBLE: 14
} as const

export const SELF_ENROLLMENT_DISPLAY_TOTAL_STEPS = 10
export const SELF_ENROLLMENT_TRACKED_TOTAL_STEPS = SELF_ENROLLMENT_STEPS.NOT_ELIGIBLE

export function getSelfEnrollmentDisplayStep(step: number) {
  if (step <= SELF_ENROLLMENT_STEPS.ELIGIBILITY) {
    return 0
  }

  if (step <= SELF_ENROLLMENT_STEPS.LOCATION_SELECTION) {
    return step - 1
  }

  if (
    step === SELF_ENROLLMENT_STEPS.REMOVED_PROGRAM_SELECTION ||
    step === SELF_ENROLLMENT_STEPS.ADDITIONAL_INFO
  ) {
    return 5
  }

  if (step === SELF_ENROLLMENT_STEPS.TRAINING_DATE) {
    return 6
  }

  if (
    step === SELF_ENROLLMENT_STEPS.REMOVED_TUITION_SUMMARY ||
    step === SELF_ENROLLMENT_STEPS.UPLOAD_DOCUMENTS
  ) {
    return 7
  }

  if (step === SELF_ENROLLMENT_STEPS.SIGN_DOCUMENTS) {
    return 8
  }

  if (step === SELF_ENROLLMENT_STEPS.SIGNED_COMPLETE) {
    return 8
  }

  if (step >= SELF_ENROLLMENT_STEPS.ENROLLMENT_COMPLETE) {
    return 9
  }

  return 0
}

export function normalizeSelfEnrollmentEntryStep(step: number | null | undefined) {
  if (typeof step !== 'number' || !Number.isFinite(step) || step <= 0) {
    return SELF_ENROLLMENT_STEPS.ELIGIBILITY
  }

  if (step === SELF_ENROLLMENT_STEPS.REMOVED_PROGRAM_SELECTION) {
    return SELF_ENROLLMENT_STEPS.ADDITIONAL_INFO
  }

  if (
    step >= SELF_ENROLLMENT_STEPS.REMOVED_TUITION_SUMMARY &&
    step <= SELF_ENROLLMENT_STEPS.SIGNED_COMPLETE
  ) {
    return step + 1
  }

  return step
}

export function getSelfEnrollmentSubmissionStep(step: number) {
  if (
    step >= SELF_ENROLLMENT_STEPS.ADDITIONAL_INFO &&
    step < SELF_ENROLLMENT_STEPS.UPLOAD_DOCUMENTS
  ) {
    return step - 1
  }

  if (
    step >= SELF_ENROLLMENT_STEPS.UPLOAD_DOCUMENTS &&
    step <= SELF_ENROLLMENT_STEPS.ENROLLMENT_COMPLETE
  ) {
    return step - 2
  }

  return step
}

export function isSelfEnrollmentTrackedStep(step: number) {
  return (
    Number.isFinite(step) &&
    step >= SELF_ENROLLMENT_STEPS.LOGIN &&
    step <= SELF_ENROLLMENT_TRACKED_TOTAL_STEPS
  )
}
